import { render, staticRenderFns } from "./on-this-page.vue?vue&type=template&id=7439ee35"
import script from "./on-this-page.vue?vue&type=script&lang=js"
export * from "./on-this-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports